import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import NestedAccessory from './NestedAccessory';
import AddButton from '../../AddButton';
import RevertButton from '../../RevertButton';
import useStyles from './styles';
import { treeStructureSettingsCustom } from '../../../../../../utils/custom_prop_types/customPropTypes';

export default function NestedAccessoriesTable({
  accessories,
  treeStructureSettings,
  handleAddAccessory,
  addedProducts,
}) {
  const classes = useStyles();

  return (
    <>
      <TableContainer className={classes.tableContainer}>
        <Table stickyHeader aria-label="sticky table" className={classes.table}>
          <TableBody>
            {accessories?.[treeStructureSettings.level]?.['hydra:member']?.map((nestedProduct) => (
              <TableRow key={nestedProduct['@id']}>
                <NestedAccessory
                  nestedProduct={nestedProduct}
                  handleAddAccessory={handleAddAccessory}
                />
                <TableCell className={classes.buttonGroup}>
                  {addedProducts.includes(nestedProduct['@id'] + nestedProduct.association)
                && (
                  <RevertButton
                    nestedProduct={nestedProduct}
                  />
                )}
                  <AddButton
                    nestedProduct={nestedProduct}
                    handleAddAccessory={handleAddAccessory}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

NestedAccessoriesTable.propTypes = {
  accessories: PropTypes.objectOf(PropTypes.any).isRequired,
  treeStructureSettings: treeStructureSettingsCustom.isRequired,
  handleAddAccessory: PropTypes.func.isRequired,
  addedProducts: PropTypes.arrayOf(PropTypes.string).isRequired,
};
